export default __webpack_public_path__ + "static/global-map-06361a07f94f5a474effa57b9d86d7c6.png";